export interface VersionInfo {
  version: string;
  commit: string;
  date: string;
}

function isVersionInfo(v: unknown): v is VersionInfo {
  if (typeof v !== 'object' || v === null) return false;
  const o = v as Record<string, unknown>;
  return (
    typeof o.version === 'string' && typeof o.commit === 'string' && typeof o.date === 'string'
  );
}

export async function fetchVersion(
  apiUrl: string,
  signal?: AbortSignal,
  fetchImpl: typeof fetch = fetch,
): Promise<VersionInfo> {
  const res = await fetchImpl(`${apiUrl}/version`, { signal });
  if (!res.ok) {
    throw new Error(`API responded with HTTP ${String(res.status)}`);
  }
  const body: unknown = await res.json();
  if (!isVersionInfo(body)) {
    throw new Error('API returned an unexpected /version payload');
  }
  return body;
}

export interface Membership {
  tenant_id: string;
  tenant_slug: string;
  tenant_name: string;
  role: string;
  site_ids?: string[];
  permissions: string[];
}

export interface Me {
  user_id: string;
  email?: string;
  platform_operator: boolean;
  memberships: Membership[];
}

function isMe(v: unknown): v is Me {
  if (typeof v !== 'object' || v === null) return false;
  const o = v as Record<string, unknown>;
  return typeof o.user_id === 'string' && Array.isArray(o.memberships);
}

/** GET /v1/me with the user's access token. */
export async function fetchMe(
  apiUrl: string,
  accessToken: string,
  signal?: AbortSignal,
  fetchImpl: typeof fetch = fetch,
): Promise<Me> {
  const res = await fetchImpl(`${apiUrl}/v1/me`, {
    signal,
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  if (!res.ok) {
    throw new Error(`API responded with HTTP ${String(res.status)}`);
  }
  const body: unknown = await res.json();
  if (!isMe(body)) {
    throw new Error('API returned an unexpected /v1/me payload');
  }
  return body;
}
